var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical icon-button",staticStyle:{"justify-content":"center","align-items":"center"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"horizontal"},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"icon-text"},[_vm._v(_vm._s(_vm.text))])],2),_vm._v(" "),_c('div',{staticClass:"selected"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7757b835","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RouterLinkIconHorizontal.vue
// module id = 2000
// module chunks = 33